module.exports = __webpack_public_path__ + "assets/img/声音.dcae5ed7.png";